import connector from 'api/http';
import config from 'shared/config';

import { SessionResponse, SessionRequestType } from './types';
import { marshalRequest } from './marshaller';

const sessionApi = (baseUrl: string = config.baseUrls.BFF_BASE_URL) => {
  const server = connector(baseUrl);

  return {
    unlockSession: (
      quoteNumber: string,
      quoteReference: string
    ): Promise<SessionResponse> =>
      Promise.resolve()
        .then(() =>
          marshalRequest(
            quoteNumber,
            quoteReference,
            SessionRequestType.UnlockSession
          )
        )
        .then((request) => server.post('/session/update', request))
        .catch((e) => Promise.reject(new Error(e))),
  };
};

export default sessionApi;
